import React from "react";

class InputNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tempValue: props.value ?? "" };
  }

  handleChange = (e) => {
    this.setState({ tempValue: e.target.value });
  };

  handleBlur = () => {
    const { onUpdate } = this.props;
    const parsed = parseFloat(this.state.tempValue);
    if (onUpdate) onUpdate(parsed); // kirim ke parent setelah selesai input
  };

  handleFocus = (e) => {
    e.target.select();
  };

  render() {
    const { value, onUpdate, ...rest } = this.props;

    return (
      <input
        {...rest}
        type="number"
        className="input-qty"
        style={{ textAlign: "right" }}
        value={this.state.tempValue}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
      />
    );
  }
}

export default InputNumber;
